package com.dotdrives.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject
import kotlin.time.Instant

@Serializable
data class ActivityEvent(
    val id: String,
    val verb: String,
    @SerialName("subject_type")
    val subjectType: String,
    @SerialName("subject_id")
    val subjectId: String,
    val payload: JsonObject,
    @SerialName("occurred_at")
    val occurredAt: Instant,
    @SerialName("actor_user_id")
    val actorUserId: String?,
)
